<!--
单页面示例：ueditor；
-->
<template>
  <scroll-right-frame class="demo-spage-3">
    <div class="rp-wrapper">
      <div class="rp-header">
        <span class="rp-header-title">主讲教师信息</span>
      </div>
      <div class="rp-body">
        <div class="rp-form editor-container">
          <vue-u-editor @ready="handleEditorReady" :ueditorConfig="ueditorConfig"></vue-u-editor>
          <div class="submit-btn">
            <button class="btn btn-solid" @click="handleSubmit">确定</button>
          </div>
        </div>
      </div>
    </div>
  </scroll-right-frame>
</template>
<script>
  import ScrollRightFrame from '../../../components/scroll-right-frame'
  import VueUEditor from 'vue-ueditor/src/components/UEditor'
  import util from '../../../libs/util'

  export default {
    name: 'demo-spage-3',
    components: {VueUEditor, ScrollRightFrame},
    data() {
      return {
        ueditorInstance: null,
        helloContent: '北国风光，千里冰封，万里雪飘。<br/>望长城内外，惟余莽莽；大河上下，顿失滔滔。<br/>山舞银蛇，原驰蜡象，欲与天公试比高。<br/>须晴日，看红装素裹，分外妖娆。<br/>江山如此多娇，引无数英雄竞折腰。<br/>惜秦皇汉武，略输文采；唐宗宋祖，稍逊风骚。<br/>一代天骄，成吉思汗，只识弯弓射大雕。<br/>俱往矣，数风流人物，还看今朝。<br/>'
      }
    },
    computed: {
      ueditorConfig: function () {
        return {
          serverUrl: util.baseUrl + '/ueditor1_4_3_3/jsp/controller.jsp'
        }
      }
    },
    methods: {
      handleEditorReady(ueditorInstance) {
        ueditorInstance.execCommand('serverparam', {
          'access_token': util.token()
        })
        this.ueditorInstance = ueditorInstance
        this.ueditorInstance.setContent(this.helloContent)
      },
      handleSubmit() {
        this.$alert(this.ueditorInstance.getContent(), '编辑器的html文本')
      }
    }
  }
</script>
<style lang="scss">
  .demo-spage-3 {
    .editor-container {
      width: 900px;
    }
    .submit-btn {
      padding-top: 10px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/demo/demo-spage-3.vue